import {createI18n} from 'vue-i18n'
import en from './locales/en.json'
import el from './locales/el.json'

const messages = {
    en: en,
    el: el,
};

const i18n = createI18n({
    legacy: false,
    locale: 'el', // default
    fallbackLocale: 'el',
    messages,
});

export default i18n;
